<template>
  <div>
    <!--Modal Question-->
    <div
      ref="modalQuestion"
      class="modal fade"
      tabindex="-1"
      id="add-questionlist-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered mw-1000px">
        <div class="modal-content rounded">
          <BlockUI :loading="block" />
          <div class="modal-header">
            <h5 class="modal-title">
              {{ translate("checklist_create_modal_h5") }}
            </h5>

            <!--begin::Close-->
            <div
              class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
              @click="closeModal"
              aria-label="Close"
            >
              <i class="bi bi-x-lg"></i>
            </div>
            <!--end::Close-->
          </div>
          <div class="title border-bottom ps-5 pe-5 pt-5">
            <div class="row align-items-center">
              <div
                class="col-lg-2 p-3 mb-5 border rounded bg-white"
                style="border-color: #e8ebee !important"
              >
                <div class="form-check form-check-custom form-check-solid">
                  <input
                    ref="modalFilterCheckbox"
                    class="form-check-input"
                    type="checkbox"
                    id="filterCheckbox"
                    @change="filterCheckBox($event)"
                    :disabled="clInfQue"
                  />
                  <div class="d-flex flex-column position-relative w-100">
                    <label
                      class="form-check-label col-form-label fs-6 p-0"
                      :class="
                        clInfQue === true ? 'text-gray-500' : 'text-gray-800'
                      "
                      for="filterCheckbox"
                    >
                      {{ translate("checklist_create_modal_checkbox_label") }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-lg-5 ps-2 pe-1 mb-5">
                <FilterInput
                  :searchId="1"
                  :PlaceHolder="
                    translate('checklist_create_modal_filter_input')
                  "
                  :filterList="filterList"
                  :InputStyle="'height:42px; font-size: 13px;'"
                  @onFilterSearch="Search"
                />
              </div>
              <div id="modal-multi-select" class="col-lg-5 ps-1 pe-1 mb-5">
                <MultiSelect
                  :disabled="clInfQue"
                  v-model="filterObject.categoryIds"
                  :options="categoryList"
                  optionLabel="Value"
                  optionValue="Id"
                  :placeholder="translate('checklist_create_modal_select')"
                  style="height: 42px"
                  @change="selectedCategory"
                >
                </MultiSelect>
              </div>
            </div>
          </div>
          <div class="modal-body rounded p-3" style="height: 475px">
            <div class="scroll overflow-y h-400px">
              <div
                v-for="question in computedQuestionList"
                :key="question.Id"
                class="d-flex align-items-center mb-1 mx-2 p-1 ps-4 pt-3 pb-3 border rounded"
                style="height: 55px"
              >
                <!--begin::Bullet-->
                <span class="bullet bullet-vertical h-40px bg-primary"></span>
                <!--end::Bullet-->

                <!--begin::Checkbox-->
                <div class="form-check form-check-custom form-check-solid mx-5">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="question.checked"
                    :id="`checklist-${question.Id}`"
                  />
                </div>
                <!--end::Checkbox-->

                <!--begin::Description-->
                <div class="flex-grow-1">
                  <div class="d-flex flex-column position-relative">
                    <label
                      class="form-check-label col-form-label fw-bold p-0 pe-5"
                      style="
                        overflow: hidden;
                        display: inline-block;
                        text-overflow: ellipsis;
                        max-width: 841px;
                        max-height: 40px;
                      "
                      :for="`checklist-${question.Id}`"
                    >
                      <span class="text-gray-900" v-if="question.Code !== null"
                        >{{ question.Code }} -
                      </span>
                      <span class="text-gray-700">{{ question.Name }}</span>
                    </label>
                  </div>
                </div>
                <!--end::Description-->
                <div style="50px">
                  <div
                    class="btn btn-icon btn-sm btn-active-light-primary mx-2"
                    @click="addQuestion(question)"
                  >
                    <i class="bi bi-plus-lg"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between p-3 pe-2">
              <div class="col-lg-10 p-0">
                <Pagination @onPage="onPage" :TotalData="records" />
              </div>
              <div class="col-lg-2 p-0">
                <button
                  @click="addQuestion()"
                  class="btn btn-sm btn-primary fs-6 w-100"
                >
                  {{ translate("Add") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Modal Question-->
    <ConfirmDialog group="exitPage"></ConfirmDialog>
    <div class="card">
      <BlockUI :loading="loading" />
      <Form
        v-slot="{ errors }"
        class="form p-0"
        novalidate="novalidate"
        @submit="saveChecklist"
        :validation-schema="checklistValidator"
      >
        <!-- Page Header Area -->
        <div class="header align-items-center px-5 py-0 border-bottom mh-75px">
          <div class="card-title p-0 m-0">
            <h5 class="d-flex flex-column m-0">
              <span>{{ translate("checklist_edit_page_title") }}</span>
              <span class="text-gray-600 fs-8 fw-light pt-1">{{
                TotalQuestionandScore(checkListModel)
              }}</span>
            </h5>
          </div>
          <div class="d-flex">
            <div
              class="btn btn-icon btn-sm btn-active-light border me-2"
              :title="translate('question_component_button_backto_list')"
              @click="router.push({ name: 'checklists' })"
            >
              <span class="svg-icon svg-icon-2">
                <inline-svg src="media/icons/duotune/arrows/arr077.svg" />
              </span>
            </div>
            <button type="submit" class="btn btn-sm btn-primary me-3">
              <div
                v-if="loadingButton"
                class="spinner-border spinner-border-sm mx-1"
              ></div>
              <span class="indicator-label">
                {{ translate("Update") }}
              </span>
            </button>
            <transition name="component-fade " mode="out-in">
              <div
                v-if="showMessage == true"
                class="d-flex justify-content-end"
              >
                <i class="bi bi-x-circle-fill fs-2 text-danger"></i>
                <span class="ms-3 fs-7 text-gray-800">
                  Kontrol listesi kullanımda</span
                >
                {{ showMessage }}
              </div>
            </transition>
          </div>
        </div>
        <!-- Page Header Area -->

        <!-- Checklist Form Area -->
        <div class="card-body px-0 border-bottom">
          <!-- Checklist Name Input -->
          <div class="row mb-4 px-10">
            <label
              class="col-lg-4 col-form-label required fw-bolder fs-5 text-gray-800"
              >{{ translate("checklist_create_input_name") }}</label
            >

            <div class="col-lg-8 fv-row d-v-container">
              <div class="fv-plugins-message-container d-v-content">
                <div class="fv-help-block ms-2 v-element">
                  <ErrorMessage name="name" />
                </div>
              </div>
              <Field
                type="text"
                name="name"
                v-model="checkListModel.name"
                :class="`form-control form-control-lg fs-6 ${
                  errors['name'] !== undefined ? 'v-invalid' : ''
                }`"
                :placeholder="translate('checklist_create_input_name')"
              />
            </div>
          </div>

          <div class="card-title px-10 pt-5">
            <h5
              class="d-flex justify-content-between align-items-center text-gray-800 py-3 m-0 pb-0"
            >
              {{ translate("checklist_page_info_title") }}
            </h5>
          </div>

          <div class="px-10">
            <!-- Multi Select Depatments -->
            <div class="row mb-7">
              <label class="col-lg-6 col-form-label fs-7 ps-5 text-gray-400">{{
                translate("checklist_page_info_description")
              }}</label>
              <div class="col-lg-12 fv-row">
                <MultiSelect
                  v-model="checkListModel.cLInfoQuestionsDepartments"
                  :options="departmentList"
                  optionLabel="Value"
                  :placeholder="translate('checklist_create_select_department')"
                  style="padding: 5px !important"
                />
              </div>
            </div>
          </div>
          <!-- Checklist Info Question Accordion -->
          <div
            v-if="checkListModel.cLInfoQuestionsDepartments.length === 0"
            class="row align-items-center px-10"
          >
            <div class="col-lg-12 fv-row position-relative">
              <div class="accordion" id="info-accordion">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="info-1">
                    <button
                      class="accordion-button collapsed ps-3 py-3 fw-bold text-gray-800"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#info-body-1"
                      aria-expanded="false"
                      aria-controls="info-body-1"
                    >
                      <div class="d-flex flex-column">
                        <span
                          class="fw-bold fs-6"
                          style="font-weight: bold !important"
                          >{{
                            translate(
                              "checklist_create_accordion_checkinfo_button"
                            )
                          }}</span
                        ><a class="fs-8 text-gray-600"
                          >{{ translate("checklist_page_number_question") }}:
                          <span class="text-primary fw-bold">{{
                            checkListModel.cLInfoQuestions[0].count
                          }}</span>
                        </a>
                      </div>
                    </button>
                  </h2>
                  <Draggable
                    id="info-body-1"
                    class="accordion-collapse collapse"
                    aria-labelledby="info-1"
                    v-model="checkListModel.cLInfoQuestions[0].questions"
                    group="people"
                    @start="drag = true"
                    @end="drag = false"
                    item-key="specificId"
                  >
                    <template class="accordion-body" #item="{ element, index }">
                      <div
                        class="d-flex align-items-center mb-1 mx-2 p-1 ps-4 py-3 border rounded"
                        style="height: 55px; background: #f9f9f9"
                      >
                        <!--begin::Bullet-->
                        <span
                          class="bullet bullet-vertical h-40px bg-primary me-5"
                        ></span>
                        <!--end::Bullet-->

                        <!--begin::Description-->
                        <div class="flex-grow-1">
                          <div class="d-flex flex-column position-relative">
                            <label
                              class="form-check-label col-form-label fw-bold p-0 pe-5"
                              style="
                                overflow: hidden;
                                display: inline-block;
                                text-overflow: ellipsis;
                                max-width: 841px;
                                max-height: 40px;
                              "
                              :for="`checklist-${element.Id + '-' + index}`"
                            >
                              <span
                                class="text-gray-900"
                                v-if="element.Code !== null"
                                >{{ element.Code }} -
                              </span>
                              <span class="text-gray-700"
                                >{{ element.Name }}
                              </span>
                            </label>
                          </div>
                        </div>
                        <!--end::Description-->
                        <div style="50px">
                          <div
                            class="btn btn-icon btn-sm btn-active-light-danger mx-2"
                            @click="deleteCLInfoQuestion(element, index, 0)"
                          >
                            <i class="bi bi-x-lg"></i>
                          </div>
                        </div>
                      </div>
                    </template>
                  </Draggable>
                </div>
              </div>
              <a
                data-bs-toggle="modal"
                data-bs-target="#add-questionlist-modal"
                class="btn bg-white btn-active-white btn-lg fs-7 text-primary me-4 position-absolute"
                style="top: 5px; right: 35px; z-index: 5"
                @click="addQuestionInfoCL(0)"
              >
                {{ translate("checklist_create_button_add_question") }}</a
              >
            </div>
          </div>

          <!-- Departmant Accordion -->
          <Draggable
            v-else
            v-model="checkListModel.cLInfoQuestions"
            @start="drag = true"
            @end="drag = false"
            item-key="departmentId"
            class="py-6 px-10"
          >
            <template class="accordion-body" #item="{ element, index }">
              <div
                class="accordion position-relative"
                :id="'accordion-' + element.departmentId"
              >
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#add-questionlist-modal"
                  class="btn bg-white btn-lg fs-7 text-primary me-4 position-absolute"
                  style="top: 5px; right: 24px; z-index: 5"
                  @click="addQuestionInfoCL(element.departmentId)"
                >
                  {{ translate("checklist_create_button_add_question") }}</a
                >
                <div class="accordion-item mb-2">
                  <h2
                    class="accordion-header"
                    :id="'header-' + element.departmentId"
                  >
                    <div class="d-flex align-items-center">
                      <button
                        class="accordion-button collapsed py-3 fw-bold text-gray-800"
                        type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="'#body-' + element.departmentId"
                        aria-expanded="false"
                        aria-controls="info-body-1"
                      >
                        <div class="d-flex flex-column">
                          <span
                            class="fw-bold fs-6"
                            style="font-weight: bold !important"
                            >{{ element.departmentName }}</span
                          ><a class="fs-8 text-gray-600"
                            >{{ translate("checklist_page_number_question") }}:
                            <span class="text-primary fw-bold">{{
                              element.count
                            }}</span>
                          </a>
                        </div>
                      </button>
                    </div>
                  </h2>
                  <div
                    :id="'body-' + element.departmentId"
                    class="accordion-collapse collapse border-top"
                    :aria-labelledby="'header-' + element.departmentId"
                  >
                    <div class="accordion-body">
                      <Draggable
                        v-model="element.questions"
                        @start="drag = true"
                        @end="drag = false"
                        item-key="specificId"
                      >
                        <template #item="{ element }">
                          <div
                            class="d-flex align-items-center mt-1 mb-1 mx-2 p-1 ps-4 py-3 border rounded"
                            style="height: 55px; background: #f9f9f9"
                          >
                            <!--begin::Bullet-->
                            <span
                              class="bullet bullet-vertical h-40px bg-primary me-5"
                            ></span>
                            <!--end::Bullet-->

                            <!--begin::Description-->
                            <div class="flex-grow-1">
                              <div class="d-flex flex-column position-relative">
                                <label
                                  class="form-check-label col-form-label fw-bold p-0 pe-5"
                                  style="
                                    overflow: hidden;
                                    display: inline-block;
                                    text-overflow: ellipsis;
                                    max-width: 841px;
                                    max-height: 40px;
                                  "
                                  :for="`checklist-${element.Id}`"
                                >
                                  <span
                                    class="text-gray-900"
                                    v-if="element.Code !== null"
                                    >{{ element.Code }} -
                                  </span>
                                  <span class="text-gray-700">{{
                                    element.Name
                                  }}</span>
                                </label>
                              </div>
                            </div>
                            <!--end::Description-->
                            <div style="50px">
                              <div
                                class="btn btn-icon btn-sm btn-active-light-danger mx-2"
                                @click="
                                  deleteCLInfoQuestion(
                                    element,
                                    null,
                                    checkListModel.cLInfoQuestions[index]
                                      .departmentId
                                  )
                                "
                              >
                                <i class="bi bi-x-lg"></i>
                              </div>
                            </div>
                          </div>
                        </template>
                      </Draggable>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Draggable>
          <!-- Departmant Accordion -->
        </div>
      </Form>
      <!-- Checklist Form Area -->

      <!-- // ! Questions Accordion -->
      <div class="card-body p-0 pt-5">
        <div class="card-title">
          <h5
            class="d-flex justify-content-between align-items-center text-gray-800 px-10 py-3 pb-0 m-0"
          >
            <span>{{ translate("checklist_create_label_department") }}</span>
          </h5>
        </div>

        <div class="px-10">
          <!-- Multi Select Depatments -->
          <div class="row mb-7">
            <label class="col-lg-6 col-form-label fs-7 ps-5 text-gray-400">{{
              translate("checklist_page_sections_description")
            }}</label>
            <div class="col-lg-12 fv-row">
              <MultiSelect
                v-model="checkListModel.departments"
                :options="departmentList"
                optionLabel="Value"
                :placeholder="translate('checklist_create_select_department')"
                style="padding: 5px !important"
              />
            </div>
          </div>

          <!-- Button Toolbar -->
          <div
            v-if="checkListModel.departments.length > 0"
            class="d-flex justify-content-end align-items-center"
          >
            <a
              v-show="selectedDepartment.length > 0"
              data-bs-toggle="modal"
              data-bs-target="#add-questionlist-modal"
              class="btn btn-sm btn-primary me-4 position-relative"
              @click="addQuestionSelectedDepartment"
              >{{ translate("checklist_create_button_selected_add_question") }}

              <span
                class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger"
                >{{ selectedDepartment.length }}</span
              >
            </a>
            <a class="btn btn-sm btn-primary" @click="selectAllDepartment"
              >{{ translate("checklist_create_button_select_all") }}
            </a>
          </div>
          <!-- Button Toolbar End -->
        </div>

        <!-- Departmant Accordion -->
        <Draggable
          v-model="checkListModel.cLquestions"
          @start="drag = true"
          @end="drag = false"
          item-key="departmentId"
          class="py-6 px-10"
        >
          <template class="accordion-body" #item="{ element, index }">
            <div
              class="accordion position-relative"
              :id="'accordion-' + element.departmentId"
            >
              <a
                data-bs-toggle="modal"
                data-bs-target="#add-questionlist-modal"
                class="btn bg-white btn-lg fs-7 text-primary me-4 position-absolute"
                style="top: 5px; right: 24px; z-index: 5"
                @click="addQuestionDepartment(element.departmentId)"
              >
                {{ translate("checklist_create_button_add_question") }}</a
              >
              <div class="accordion-item mb-2">
                <h2
                  class="accordion-header"
                  :id="'header-' + element.departmentId"
                >
                  <div class="d-flex align-items-center">
                    <div
                      v-if="checkListModel.departments.length > 0"
                      class="form-check form-check-custom form-check-solid ps-6"
                    >
                      <input
                        class="form-check-input"
                        :value="element.departmentId"
                        @change="addQuestionCheckBox($event)"
                        type="checkbox"
                        :id="`checkbox-${element.departmentId}`"
                        :ref="
                          (el) => {
                            inputCheckBoxs[`checkbox-${element.departmentId}`] =
                              el;
                          }
                        "
                      />
                    </div>

                    <button
                      class="accordion-button collapsed py-3 fw-bold text-gray-800"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#body-' + element.departmentId"
                      aria-expanded="false"
                      aria-controls="info-body-1"
                    >
                      <div class="d-flex flex-column">
                        <span
                          class="fw-bold fs-6"
                          style="font-weight: bold !important"
                          >{{ element.departmentName }}</span
                        ><a class="fs-8 text-gray-600"
                          >{{ translate("checklist_page_number_question") }}:
                          <span class="text-primary fw-bold">{{
                            element.count
                          }}</span>
                          / {{ translate("checklist_page_score") }}:
                          <span class="text-primary">
                            {{ element.score }}
                          </span></a
                        >
                      </div>
                    </button>
                  </div>
                </h2>
                <div
                  :id="'body-' + element.departmentId"
                  class="accordion-collapse collapse border-top"
                  :aria-labelledby="'header-' + element.departmentId"
                >
                  <div class="accordion-body">
                    <!-- Info Question Accordion -->
                    <div
                      v-show="element.info.length > 0"
                      class="accordion position-relative"
                      id="department-info-question"
                    >
                      <div class="accordion-item mb-2">
                        <h2
                          class="accordion-header"
                          id="header-department-info-question"
                        >
                          <button
                            class="accordion-button collapsed pt-5 pb-5 fw-bold text-gray-800"
                            style="font-weight: 600 !important"
                            type="button"
                            data-bs-toggle="collapse"
                            :data-bs-target="
                              '#body-department-info-question' +
                              checkListModel.cLquestions[index].departmentId
                            "
                            aria-expanded="false"
                            aria-controls="info-body-1"
                          >
                            {{
                              translate(
                                "checklist_create_accordion_button_info"
                              )
                            }}
                          </button>
                        </h2>
                        <Draggable
                          :id="
                            'body-department-info-question' +
                            checkListModel.cLquestions[index].departmentId
                          "
                          class="accordion-collapse collapse border-top"
                          aria-labelledby="header-department-info-question"
                          v-model="checkListModel.cLquestions[index].info"
                          @start="drag = true"
                          @end="drag = false"
                          item-key="specificId"
                        >
                          <template class="accordion-body" #item="{ element }">
                            <div
                              class="d-flex align-items-center mt-1 mb-1 mx-2 p-1 ps-4 py-3 border rounded"
                              style="height: 55px; background: #f9f9f9"
                            >
                              <!--begin::Bullet-->
                              <span
                                class="bullet bullet-vertical h-40px bg-primary me-5"
                              ></span>
                              <!--end::Bullet-->

                              <!--begin::Description-->
                              <div class="flex-grow-1">
                                <div
                                  class="d-flex flex-column position-relative"
                                >
                                  <label
                                    class="form-check-label col-form-label fw-bold p-0 pe-5"
                                    style="
                                      overflow: hidden;
                                      display: inline-block;
                                      text-overflow: ellipsis;
                                      max-width: 841px;
                                      max-height: 40px;
                                    "
                                    :for="`checklist-${element.Id}`"
                                  >
                                    <span
                                      class="text-gray-900"
                                      v-if="element.Code !== null"
                                      >{{ element.Code }} -
                                    </span>
                                    <span class="text-gray-700">{{
                                      element.Name
                                    }}</span>
                                  </label>
                                </div>
                              </div>
                              <!--end::Description-->
                              <div style="50px">
                                <div
                                  class="btn btn-icon btn-sm btn-active-light-danger mx-2"
                                  @click="
                                    deleteInfoQuestion(
                                      checkListModel.cLquestions[index],
                                      checkListModel.cLquestions[index].info,
                                      element
                                    )
                                  "
                                >
                                  <i class="bi bi-x-lg"></i>
                                </div>
                              </div>
                            </div>
                          </template>
                        </Draggable>
                      </div>
                    </div>
                    <!-- Info Question Accordion -->

                    <!-- Category Question Accordion -->
                    <Draggable
                      v-model="checkListModel.cLquestions[index].categorys"
                      @start="drag = true"
                      @end="drag = false"
                      item-key="id"
                    >
                      <template class="accordion-body" #item="{ element }">
                        <div
                          class="accordion position-relative"
                          :id="
                            'accordion-category' +
                            element.id +
                            checkListModel.cLquestions[index].departmentId
                          "
                        >
                          <div class="accordion-item mb-2">
                            <h2
                              class="accordion-header"
                              :id="
                                'header-category' +
                                element.id +
                                checkListModel.cLquestions[index].departmentId
                              "
                            >
                              <button
                                class="accordion-button collapsed pt-5 pb-5 fw-bold text-gray-800"
                                style="font-weight: 600 !important"
                                type="button"
                                data-bs-toggle="collapse"
                                :data-bs-target="
                                  '#body-category' +
                                  element.id +
                                  checkListModel.cLquestions[index].departmentId
                                "
                                aria-expanded="false"
                                aria-controls="info-body-1"
                              >
                                {{ element.name }}
                              </button>
                            </h2>
                            <Draggable
                              :id="
                                'body-category' +
                                element.id +
                                checkListModel.cLquestions[index].departmentId
                              "
                              class="accordion-collapse collapse border-top"
                              :aria-labelledby="
                                'header-category' +
                                element.id +
                                checkListModel.cLquestions[index].departmentId
                              "
                              v-model="element.questions"
                              @start="drag = true"
                              @end="drag = false"
                              item-key="Id"
                            >
                              <template
                                class="accordion-body"
                                #item="{ element }"
                              >
                                <div
                                  class="d-flex align-items-center mt-1 mb-1 mx-2 p-1 ps-4 py-3 border rounded"
                                  style="height: 55px; background: #f9f9f9"
                                >
                                  <!--begin::Bullet-->
                                  <span
                                    class="bullet bullet-vertical h-40px bg-primary me-5"
                                  ></span>
                                  <!--end::Bullet-->

                                  <!--begin::Description-->
                                  <div class="flex-grow-1">
                                    <div
                                      class="d-flex flex-column position-relative"
                                    >
                                      <label
                                        class="form-check-label col-form-label fw-bold p-0 pe-5"
                                        style="
                                          overflow: hidden;
                                          display: inline-block;
                                          text-overflow: ellipsis;
                                          max-width: 841px;
                                          max-height: 40px;
                                        "
                                        :for="`checklist-${element.Id}`"
                                      >
                                        <span
                                          class="text-gray-900"
                                          v-if="element.Code !== null"
                                          >{{ element.Code }} -
                                        </span>
                                        <span class="text-gray-700">{{
                                          element.Name
                                        }}</span>
                                      </label>
                                    </div>
                                  </div>
                                  <!--end::Description-->
                                  <div style="50px">
                                    <div
                                      class="btn btn-icon btn-sm btn-active-light-danger mx-2"
                                      @click="
                                        deleteQuestion(
                                          checkListModel.cLquestions[index],
                                          element.Id
                                        )
                                      "
                                    >
                                      <i class="bi bi-x-lg"></i>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </Draggable>
                          </div>
                        </div>
                      </template>
                    </Draggable>
                    <!-- Category Question Accordion -->
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Draggable>
        <!-- Departmant Accordion -->
      </div>
      <!-- Questions Accordion -->
    </div>
  </div>
</template>

<script setup>
import { hideModal } from "@/core/helpers/dom";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import DepartmentModule from "@/store/modules/Audit/DepartmentModule";
import {
  computed,
  onBeforeUpdate,
  reactive,
  ref,
  onMounted,
  watch,
} from "vue-demi";
import { ElMessage } from "element-plus";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { onBeforeRouteLeave, useRoute } from "vue-router";
import router from "@/router";
import { useConfirm } from "primevue/useconfirm";
import Draggable from "vuedraggable";

import CheckListModule from "@/store/modules/Audit/CheckListModule";

// Multi Language
const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const confirm = useConfirm();
let firstData = null;

//Store Tanımlaması
const store = useStore();
const route = useRoute();
const clId = route.params.id;
const loading = ref(true);
const loadingButton = ref(false);

const checkListModel = reactive({
  id: 0,
  name: null,

  cLInfoQuestions: [
    {
      departmentId: 0,
      departmentName: translate("checklist_question_button"),
      questions: [],
      count: 0,
    },
  ],
  cLInfoQuestionsDepartments: [],
  departments: [],
  cLquestions: [
    {
      departmentId: 0,
      departmentName: translate("checklist_question_button"),
      info: [],
      categorys: [],
      count: 0,
      score: 0,
    },
  ],
});
const TotalQuestionandScore = (model) => {
  let totalQuestion = 0;
  let score = 0;
  model.cLInfoQuestions.forEach((dep) => {
    totalQuestion = totalQuestion + dep.count;
  });
  model.cLquestions.forEach((dep) => {
    totalQuestion = totalQuestion + dep.count;
    score = score + dep.score;
  });

  let detail =
    translate("checklist_page_total_number_question") +
    ": " +
    totalQuestion +
    " - " +
    translate("checklist_page_total_score") +
    ": " +
    score;
  return detail;
};

watch(
  () => checkListModel.cLInfoQuestionsDepartments,
  (newDepartments, oldDepartments) => {
    //Yeni Bir Departman Eklendi Demek
    if (newDepartments.length > oldDepartments.length) {
      let index = checkListModel.cLInfoQuestions.findIndex(
        (i) => i.departmentId === 0
      );
      if (index !== -1) {
        checkListModel.cLInfoQuestions.splice(index, 1);
      }

      newDepartments.forEach((department) => {
        let status = oldDepartments.some((item) => item.Id === department.Id);
        if (!status) {
          let modelList = {
            departmentId: department.Id,
            departmentName: department.Value,
            questions: [],
            count: 0,
          };
          checkListModel.cLInfoQuestions.push(modelList);
        }
      });
    }
    //Bir Departman Çıkartıldı Demek
    if (newDepartments.length < oldDepartments.length) {
      if (newDepartments.length === 0) {
        checkListModel.cLInfoQuestions = [];
        selectedDepartment.value = [];
        let modelList = {
          departmentId: 0,
          departmentName: translate("Menu_Audit_Questions"),
          questions: [],
          count: 0,
        };
        checkListModel.cLInfoQuestions.push(modelList);
      } else {
        oldDepartments.forEach((department) => {
          let status = newDepartments.some((item) => item.Id === department.Id);
          if (!status) {
            let index = checkListModel.cLInfoQuestions.findIndex(
              (item) => item.departmentId === department.Id
            );

            checkListModel.cLInfoQuestions.splice(index, 1);
          }
        });
      }
    }
  },
  { deep: true }
);
//Departman sayısında değişiklik olduğunda bölümlerin ayarlanması için watch ile takip yapılır
watch(
  () => checkListModel.departments,
  (newDepartments, oldDepartments) => {
    //Yeni Bir Departman Eklendi Demek
    if (newDepartments.length > oldDepartments.length) {
      let index = checkListModel.cLquestions.findIndex(
        (i) => i.departmentId === 0
      );
      if (index !== -1) {
        checkListModel.cLquestions.splice(index, 1);
      }

      newDepartments.forEach((department) => {
        let status = oldDepartments.some((item) => item.Id === department.Id);
        if (!status) {
          let modelList = {
            departmentId: department.Id,
            departmentName: department.Value,
            info: [],
            categorys: [],
            count: 0,
            score: 0,
          };
          checkListModel.cLquestions.push(modelList);
        }
      });
    }
    //Bir Departman Çıkartıldı Demek
    if (newDepartments.length < oldDepartments.length) {
      if (newDepartments.length === 0) {
        checkListModel.cLquestions = [];
        selectedDepartment.value = [];
        let modelList = {
          departmentId: 0,
          departmentName: translate("Menu_Audit_Questions"),
          info: [],
          categorys: [],
          count: 0,
          score: 0,
        };
        checkListModel.cLquestions.push(modelList);
      } else {
        oldDepartments.forEach((department) => {
          let status = newDepartments.some((item) => item.Id === department.Id);
          if (!status) {
            let index = checkListModel.cLquestions.findIndex(
              (item) => item.departmentId === department.Id
            );

            checkListModel.cLquestions.splice(index, 1);
          }
        });
      }
    }
  },
  { deep: true }
);

store
  .dispatch("CheckListModule/GET_CHECKLIST", clId)
  .then((response) => {
    checkListModel.id = clId;
    checkListModel.name = response.Name;

    response.Questions.forEach((question) => {
      let qObject = {
        Id: question.Id,
        Name: question.QuestionText,
        CategoryName:
          question.CategoryId !== 0
            ? question.CategoryName
            : translate("Other"),
        CategoryId: question.CategoryId,
        Code: question.Code,
        InfoOnly: question.InfoOnly,
        Score: question.Score,
        Answers: [],
        ChecklistQuestionId: question.ChecklistQuestionId,
        specificId: null,
      };

      // CL Info Bölümleri
      if (question.IsGeneral) {
        qObject.CategoryName = null;
        if (
          question.DepartmentId !== 0 &&
          checkListModel.cLInfoQuestions[0].departmentId === 0
        ) {
          checkListModel.cLInfoQuestions = [];
        }
        if (question.DepartmentId === 0) {
          let item = checkListModel.cLInfoQuestions[0].questions;
          qObject.specificId = createSpecificId(item);
          item.push(qObject);
          checkListModel.cLInfoQuestions[0].count++;
        } else if (
          checkListModel.cLInfoQuestions.some(
            (i) => i.departmentId === question.DepartmentId
          )
        ) {
          let item = checkListModel.cLInfoQuestions.find(
            (i) => i.departmentId === question.DepartmentId
          );

          qObject.specificId = createSpecificId(item.questions);
          item.questions.push(qObject);
          item.count++;
        } else {
          let deparmantObj = {
            departmentId: question.DepartmentId,
            departmentName: question.DepartmentName,
            questions: [],
            count: 1,
          };
          let dpt = {
            Id: question.DepartmentId.toString(),
            Value: question.DepartmentName,
          };
          qObject.specificId = createSpecificId([]);
          deparmantObj.questions.push(qObject);
          checkListModel.cLInfoQuestions.push(deparmantObj);
          checkListModel.cLInfoQuestionsDepartments.push(dpt);
        }
      }

      // Bölümler
      else {
        if (question.DepartmentId === 0 && question.InfoOnly) {
          let item = checkListModel.cLquestions[0];
          qObject.specificId = createSpecificId(item.info);
          item.info.push(qObject);
          item.count++;
        }
        if (question.DepartmentId === 0 && !question.InfoOnly) {
          let department = checkListModel.cLquestions[0];
          let category = department.categorys.find(
            (c) => c.id === question.CategoryId.toString()
          );
          if (category === undefined) {
            let ctgry = {
              id: question.CategoryId.toString(),
              name:
                question.CategoryId !== 0
                  ? question.CategoryName
                  : translate("Other"),
              questions: [],
            };

            qObject.specificId = createSpecificId([]);
            ctgry.questions.push(qObject);

            department.categorys.push(ctgry);
            department.count++;
            department.score = department.score + qObject.Score;
          } else {
            qObject.specificId = createSpecificId([]);
            category.questions.push(qObject);
            department.count++;
            department.score = department.score + qObject.Score;
          }
        }
        if (
          question.DepartmentId !== 0 &&
          checkListModel.cLquestions[0].departmentId === 0
        ) {
          checkListModel.cLquestions = [];
        }
        if (question.DepartmentId > 0) {
          let department = checkListModel.cLquestions.find(
            (d) => d.departmentId === question.DepartmentId.toString()
          );

          //Departman Mevcut Değilse
          if (department === undefined) {
            let dpt = {
              departmentId: question.DepartmentId.toString(),
              departmentName: question.DepartmentName,
              info: [],
              categorys: [],
              count: 0,
              score: 0,
            };

            let dptValue = {
              Id: question.DepartmentId.toString(),
              Value: question.DepartmentName,
            };
            // Gelen Soru Türü Info ise
            if (question.InfoOnly) {
              qObject.specificId = createSpecificId([]);
              dpt.info.push(qObject);
              dpt.count++;
            }
            //Gelen Soru Info Değil ise
            else {
              let ctgry = {
                id: question.CategoryId.toString(),
                name:
                  question.CategoryId !== 0
                    ? question.CategoryName
                    : translate("Other"),
                questions: [],
              };
              qObject.specificId = createSpecificId([]);
              ctgry.questions.push(qObject);
              dpt.categorys.push(ctgry);
              dpt.count++;
              dpt.score = question.Score;
            }

            checkListModel.departments.push(dptValue);
            checkListModel.cLquestions.push(dpt);
          }

          // Departman Mevcutsa
          else {
            // Gelen Soru Türü Info ise
            if (question.InfoOnly) {
              qObject.specificId = createSpecificId([]);
              department.info.push(qObject);
              department.count++;
            }
            // Gelen Soru Türü Info Değilse
            else {
              let category = department.categorys.find(
                (c) => c.id === question.CategoryId.toString()
              );

              //Kategori yoksa

              if (category === undefined) {
                let ctgry = {
                  id: question.CategoryId.toString(),
                  name:
                    question.CategoryId !== 0
                      ? question.CategoryName
                      : translate("Other"),
                  questions: [],
                };
                qObject.specificId = createSpecificId([]);
                ctgry.questions.push(qObject);
                department.categorys.push(ctgry);
                department.count++;
                department.score = department.score + question.Score;
              }
              // Kategori varssa
              else {
                qObject.specificId = createSpecificId([]);
                category.questions.push(qObject);
                department.count++;
                department.score = department.score + question.Score;
              }
            }
          }
        }
      }
    });

    setCurrentPageBreadcrumbs(checkListModel.name, [
      translate("checklist_create_breadcrumbs_list"),
    ]);
  })
  .finally(() => {
    loading.value = false;
    //Data da bir değişiklik var mı? diye kontrol etmek amaçlı oluşturulmuştur.
    firstData = JSON.stringify(checkListModel);
  });

watch(locale, () => {
  setCurrentPageBreadcrumbs(checkListModel.name, [
    translate("checklist_create_breadcrumbs_list"),
  ]);
});

const showMessage = ref(false);
const saveChecklist = () => {
  loadingButton.value = true;
  let departmentControl = false;
  checkListModel.cLquestions.forEach((item) => {
    if (item.categorys.length === 0) {
      setTimeout(() => {
        alertMessage(
          item.departmentName + translate("checklist_msg_add_question_1"),
          "error"
        );
      }, 50);
      departmentControl = true;
      loadingButton.value = false;
    }
  });

  if (!departmentControl) {
    let payload = {
      id: clId,
      name: checkListModel.name,
      questions: [],
    };

    if (checkListModel.cLInfoQuestionsDepartments.length === 0) {
      if (checkListModel.cLInfoQuestions[0].questions.length > 0) {
        checkListModel.cLInfoQuestions[0].questions.forEach((infoQuestion) => {
          let infoModel = {
            Id: 0,
            isGeneral: false,
            DepartmentId: 0,
            ChecklistQuestionId: 0,
          };
          infoModel.ChecklistQuestionId =
            infoQuestion.ChecklistQuestionId === undefined
              ? 0
              : infoQuestion.ChecklistQuestionId;
          infoModel.Id = infoQuestion.Id;
          infoModel.isGeneral = true;
          infoModel.DepartmentId = 0;
          payload.questions.push(infoModel);
        });
      }
    } else {
      checkListModel.cLInfoQuestions.forEach((department) => {
        if (department.questions.length > 0) {
          department.questions.forEach((infoQuestion) => {
            let infoModel = {
              Id: 0,
              isGeneral: false,
              DepartmentId: 0,
              ChecklistQuestionId: 0,
            };
            infoModel.ChecklistQuestionId =
              infoQuestion.ChecklistQuestionId === undefined
                ? 0
                : infoQuestion.ChecklistQuestionId;
            infoModel.Id = infoQuestion.Id;
            infoModel.isGeneral = true;
            infoModel.DepartmentId = department.departmentId;
            payload.questions.push(infoModel);
          });
        }
      });
    }

    checkListModel.cLquestions.forEach((item) => {
      item.info.forEach((info) => {
        let infoModel = {
          Id: 0,
          isGeneral: false,
          DepartmentId: 0,
          ChecklistQuestionId: 0,
        };

        infoModel.DepartmentId = item.departmentId;
        infoModel.Id = info.Id;
        infoModel.ChecklistQuestionId =
          info.ChecklistQuestionId === undefined ? 0 : info.ChecklistQuestionId;
        payload.questions.push(infoModel);
      });
      item.categorys.forEach((category) => {
        category.questions.forEach((q) => {
          let infoModel = {
            Id: 0,
            isGeneral: false,
            DepartmentId: 0,
            ChecklistQuestionId: 0,
          };

          infoModel.DepartmentId = item.departmentId;
          infoModel.Id = q.Id;
          infoModel.ChecklistQuestionId =
            q.ChecklistQuestionId === undefined ? 0 : q.ChecklistQuestionId;
          payload.questions.push(infoModel);
        });
      });
    });
    store
      .dispatch("CheckListModule/CREATE_OR_UPDATE_CHECKLIST", payload)
      .then((response) => {
        if (response) {
          updatedTrue = true;
          router.push({ name: "checklists" });
          loadingButton.value = false;
        } else {
          loadingButton.value = false;
        }
      })
      .finally(() => {
        loadingButton.value = false;
      });
  }
};

const modalQuestion = ref();

const closeModal = () => {
  hideModal(modalQuestion.value);
};

// Validation Tanımlaması
const checklistValidator = Yup.object().shape({
  name: Yup.string()
    .nullable()
    .required(translate("checklist_name_validation")),
});

const departmentList = ref([]);

// Soru eklemek için seçili departmanların tutulma funksiyonu
onBeforeUpdate(() => {
  inputCheckBoxs.value = {};
});

let inputCheckBoxs = ref({});
const selectedDepartment = ref([]);

const selectAllDepartment = () => {
  if (selectedDepartment.value.length === checkListModel.departments.length) {
    selectedDepartment.value.forEach((department) => {
      inputCheckBoxs.value[`checkbox-${department}`].checked = false;
    });
    selectedDepartment.value = [];
  } else {
    selectedDepartment.value = [];
    checkListModel.departments.forEach((department) => {
      inputCheckBoxs.value[`checkbox-${department.Id}`].checked = true;
      selectedDepartment.value.push(department.Id);
    });
  }
};

const addQuestionCheckBox = (event) => {
  if (event.target.checked) {
    selectedDepartment.value.push(event.target.value);
  } else {
    let index = selectedDepartment.value.indexOf(event.target.value);
    selectedDepartment.value.splice(index, 1);
  }
};

const addAddress = ref(null);

// Add Department Modal Question
const selectedDepartmantId = ref(0);
const addQuestionDepartment = (departmentId) => {
  addAddress.value = true;
  selectedDepartmantId.value = departmentId;
  getQuestion(filterObject);
};
// Add CL Question Modal Info
const modalFilterCheckbox = ref();
const clInfQue = ref(false);
let clInfoQuestionSelectDepartmentId = null;
const addQuestionInfoCL = (deparmantId) => {
  clInfoQuestionSelectDepartmentId = deparmantId;
  modalFilterCheckbox.value.checked = true;
  clInfQue.value = true;
  addAddress.value = null;
  filterObject.infoStatus = 1;
  getQuestion(filterObject);
};
// Add Selected Department Modal Question
const addQuestionSelectedDepartment = () => {
  addAddress.value = false;
  getQuestion(filterObject);
};

//Get departments
DepartmentModule.actions.GET_COMMON_DEPARTMENT().then((response) => {
  departmentList.value = response;
});

//Get Questions
const block = ref(false);
const categoryList = ref([]);
store.dispatch("CategoryModule/GET_COMMON_CATEGORY").then((Response) => {
  categoryList.value = Response;
});

const records = ref(0);
const computedQuestionList = computed(() => questionList.value);
const questionList = ref([]);
const filterList = ref(["questionText", "code"]);
const filterObject = reactive({
  page: 1,
  pageSize: 10,
  questionText: null,
  code: null,
  categoryIds: [],
  infoStatus: 2,
});

const Search = (filter) => {
  if (filter !== null) {
    Object.keys(filter).forEach((i) => {
      if (i === "questionText") {
        filterObject.questionText = filter[i];
      } else {
        filterObject.code = filter[i];
      }
    });
  } else {
    filterObject.questionText = null;
    filterObject.code = null;
  }
  getQuestion(filterObject);
};

const selectedCategory = () => {
  getQuestion(filterObject);
};

const filterCheckBox = (e) => {
  filterObject.infoStatus = e.target.checked === true ? 1 : 2;
  getQuestion(filterObject);
};

const onPage = (e) => {
  if (
    filterObject.page !== e.step.value ||
    filterObject.pageSize !== e.pageSize.value
  ) {
    filterObject.page = e.step.value;
    filterObject.pageSize = e.pageSize.value;
    getQuestion(filterObject);
  }
};

const getQuestion = (payload) => {
  block.value = true;
  store
    .dispatch("CheckListModule/GET_CHECKLISTS_QUESTİON", payload)
    .then((response) => {
      questionList.value = [];
      records.value = response.TotalItemsCount;
      response.ListItems.forEach((question) => {
        let qObject = {
          Id: 0,
          Name: null,
          CategoryName: null,
          CategoryId: 0,
          Code: null,
          InfoOnly: false,
          Score: 0,
          Answers: [],
          checked: false,
        };
        qObject.Id = question.Id;
        qObject.Name = question.QuestionText;
        qObject.CategoryId =
          question.CategoryId !== 0 ? question.CategoryId : 0;
        qObject.CategoryName =
          question.CategoryId !== 0
            ? question.CategoryName
            : translate("Other");
        if (question.InfoOnly) {
          qObject.CategoryId = "ab";
          qObject.CategoryName = "Info";
        }
        qObject.InfoOnly = question.InfoOnly;
        qObject.Score = question.Score;
        qObject.Answers = question.Answers;
        qObject.Code = question.Code;
        questionList.value.push(qObject);
      });
    })
    .finally(() => (block.value = false));
};

const alertMessage = (msg, type) => {
  ElMessage({
    message: msg,
    grouping: true,
    type: type,
  });
};

const addQuestion = (question) => {
  if (question !== undefined) {
    if (addAddress.value === true) {
      qfunction(question);
    } else if (addAddress.value === false) {
      selectedDepartment.value.forEach((i) =>
        checkListModel.cLquestions.forEach((deparmant) => {
          qselectfunction(question, deparmant, i);
        })
      );
    } else if (addAddress.value === null) {
      if (clInfoQuestionSelectDepartmentId === 0) {
        let newQuestion = createSpecificIdQuestion(
          question,
          checkListModel.cLInfoQuestions[0].questions
        );
        checkListModel.cLInfoQuestions[0].questions.push(newQuestion);
        checkListModel.cLInfoQuestions[0].count++;
        setTimeout(() => {
          alertMessage(translate("checklist_msg_add_question"), "success");
        }, 50);
      } else {
        let index = checkListModel.cLInfoQuestions.findIndex(
          (i) => i.departmentId === clInfoQuestionSelectDepartmentId
        );
        let newQuestion = createSpecificIdQuestion(
          question,
          checkListModel.cLInfoQuestions[index].questions
        );
        checkListModel.cLInfoQuestions[index].questions.push(newQuestion);
        checkListModel.cLInfoQuestions[index].count++;
        setTimeout(() => {
          alertMessage(translate("checklist_msg_add_question"), "success");
        }, 50);
      }
    }
  } else {
    //Birden çok soru seçilip eklendiğinde

    let selectedQuestion = computedQuestionList.value.filter(
      (question) => question.checked === true
    );

    selectedQuestion.forEach((question) => {
      if (addAddress.value === true) {
        qfunction(question);
      } else if (addAddress.value === false) {
        selectedDepartment.value.forEach((i) =>
          checkListModel.cLquestions.forEach((deparmant) => {
            qselectfunction(question, deparmant, i);
          })
        );
      } else if (addAddress.value === null) {
        if (clInfoQuestionSelectDepartmentId === 0) {
          let newQuestion = createSpecificIdQuestion(
            question,
            checkListModel.cLInfoQuestions[0].questions
          );
          checkListModel.cLInfoQuestions[0].questions.push(newQuestion);
          checkListModel.cLInfoQuestions[0].count++;
          setTimeout(() => {
            alertMessage(translate("checklist_msg_add_question"), "success");
          }, 50);
        } else {
          let index = checkListModel.cLInfoQuestions.findIndex(
            (i) => i.departmentId === clInfoQuestionSelectDepartmentId
          );
          let newQuestion = createSpecificIdQuestion(
            question,
            checkListModel.cLInfoQuestions[index].questions
          );
          checkListModel.cLInfoQuestions[index].questions.push(newQuestion);
          checkListModel.cLInfoQuestions[index].count++;
          setTimeout(() => {
            alertMessage(translate("checklist_msg_add_question"), "success");
          }, 50);
        }
      }
    });
  }
};

//Create specific Id for Info Question return QUESTİON
const createSpecificIdQuestion = (question, array) => {
  let newQuestion = JSON.parse(JSON.stringify(question));
  let specificId = new Date().getTime() + array.length;
  newQuestion.specificId = specificId;
  return newQuestion;
};

//Create specific Id for Info Question return QUESTİON
const createSpecificId = (array) => {
  let specificId = new Date().getTime() + array.length;
  return specificId;
};

const qselectfunction = (question, deparmant, i) => {
  if (deparmant.departmentId.toString() === i.toString()) {
    if (question.InfoOnly === true) {
      let newQuestion = createSpecificIdQuestion(question, deparmant.info);

      deparmant.info.push(newQuestion);
      deparmant.count++;
      setTimeout(() => {
        alertMessage(translate("checklist_msg_add_question"), "success");
      }, 50);
    } else {
      let category = {
        id: 0,
        name: null,
        questions: [],
      };
      if (deparmant.categorys.length > 0) {
        if (
          deparmant.categorys.some(
            (i) => i.id.toString() === question.CategoryId.toString()
          )
        ) {
          deparmant.categorys.forEach((category) => {
            if (category.id.toString() === question.CategoryId.toString()) {
              if (
                category.questions.some(
                  (x) => x.Id.toString() === question.Id.toString()
                ) !== true
              ) {
                category.questions.push(question);
                deparmant.count++;
                deparmant.score = deparmant.score + question.Score;
                setTimeout(() => {
                  alertMessage(
                    translate("checklist_msg_add_question"),
                    "success"
                  );
                }, 50);
              } else {
                setTimeout(() => {
                  alertMessage(
                    question.Name +
                      " " +
                      deparmant.departmentName +
                      translate("checklist_msg_add_error_question"),
                    "warning"
                  );
                }, 50);
              }
            }
          });
        } else {
          category.id = question.CategoryId;
          category.name = question.CategoryName;
          category.questions.push(question);
          deparmant.categorys.push(category);
          deparmant.count++;
          deparmant.score = deparmant.score + question.Score;
          setTimeout(() => {
            alertMessage(translate("checklist_msg_add_question"), "success");
          }, 50);
        }
      } else {
        category.id = question.CategoryId;
        category.name = question.CategoryName;
        category.questions.push(question);
        deparmant.categorys.push(category);
        deparmant.count++;
        deparmant.score = deparmant.score + question.Score;
        setTimeout(() => {
          alertMessage(translate("checklist_msg_add_question"), "success");
        }, 50);
      }
      deparmant.categorys = deparmant.categorys.sort(function (a, b) {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
      });
    }
  }
};

const qfunction = (question) => {
  checkListModel.cLquestions.forEach((item) => {
    if (
      item.departmentId.toString() === selectedDepartmantId.value.toString()
    ) {
      if (question.InfoOnly === true) {
        let newQuestion = createSpecificIdQuestion(question, item.info);
        item.info.push(newQuestion);
        item.count++;
        setTimeout(() => {
          alertMessage(translate("checklist_msg_add_question"), "success");
        }, 50);
      } else {
        let category = {
          id: 0,
          name: null,
          questions: [],
        };
        if (item.categorys.length > 0) {
          if (
            item.categorys.some(
              (i) => i.id.toString() === question.CategoryId.toString()
            )
          ) {
            item.categorys.forEach((category) => {
              if (category.id.toString() === question.CategoryId.toString()) {
                if (
                  category.questions.some(
                    (x) => x.Id.toString() === question.Id.toString()
                  ) !== true
                ) {
                  category.questions.push(question);
                  item.count++;
                  item.score = item.score + question.Score;
                  setTimeout(() => {
                    alertMessage(
                      translate("checklist_msg_add_question"),
                      "success"
                    );
                  }, 50);
                } else {
                  setTimeout(() => {
                    alertMessage(
                      question.Name +
                        " " +
                        item.departmentName +
                        translate("checklist_msg_add_error_question"),
                      "warning"
                    );
                  }, 50);
                }
              }
            });
          } else {
            category.id = question.CategoryId;
            category.name = question.CategoryName;
            category.questions.push(question);
            item.categorys.push(category);
            item.count++;
            item.score = item.score + question.Score;
            setTimeout(() => {
              alertMessage(translate("checklist_msg_add_question"), "success");
            }, 50);
          }
        } else {
          category.id = question.CategoryId;
          category.name = question.CategoryName;
          category.questions.push(question);
          item.categorys.push(category);
          item.count++;
          item.score = item.score + question.Score;
          setTimeout(() => {
            alertMessage(translate("checklist_msg_add_question"), "success");
          }, 50);
        }
        item.categorys = item.categorys.sort(function (a, b) {
          return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
        });
      }
    }
  });
};

const deleteQuestion = (department, questionId) => {
  department.categorys.forEach((category) => {
    category.questions.forEach((question) => {
      if (question.Id.toString() === questionId.toString()) {
        category.questions = category.questions.filter(
          (q) => q.Id.toString() !== questionId.toString()
        );
        department.count--;
        department.score = department.score - question.Score;
        if (category.questions.length === 0) {
          department.categorys = department.categorys.filter(
            (c) => c.id.toString() !== category.id.toString()
          );
        }
      }
    });
  });
};

const deleteInfoQuestion = (department, infoList, question) => {
  infoList.forEach((q) => {
    if (q.specificId.toString() === question.specificId.toString()) {
      let index = infoList.findIndex(
        (i) => i.specificId.toString() === question.specificId.toString()
      );
      infoList.splice(index, 1);
      department.count--;
    }
  });
};

const deleteCLInfoQuestion = (question, index, deparmantId) => {
  if (parseInt(deparmantId) === 0) {
    checkListModel.cLInfoQuestions[0].questions.splice(index, 1);
    checkListModel.cLInfoQuestions[0].count--;
  } else {
    let department = checkListModel.cLInfoQuestions.find(
      (i) => i.departmentId.toString() === deparmantId.toString()
    );
    let i = department.questions.findIndex(
      (q) => q.specificId.toString() === question.specificId.toString()
    );
    department.questions.splice(i, 1);
    department.count--;
  }
};

onMounted(() => {
  document
    .getElementById("add-questionlist-modal")
    .addEventListener("hide.bs.modal", function () {
      setTimeout(() => {
        clInfQue.value = false;
        modalFilterCheckbox.value.checked = false;
        filterObject.page = 1;
        filterObject.pageSize = 10;
        filterObject.questionText = null;
        filterObject.code = null;
        filterObject.categoryIds = [];
        filterObject.infoStatus = 2;
        questionList.value = [];
      }, 400);
    });
});

let updatedTrue = false;
onBeforeRouteLeave((to, from, next) => {
  if (updatedTrue === false) {
    let status = true;
    if (firstData !== JSON.stringify(checkListModel)) {
      status = false;
    }

    if (!status) {
      confirm.require({
        group: "exitPage",
        message: translate("confirm_exit_page"),
        header: "Confirmation",
        icon: "bi bi-exclamation-lg",
        acceptLabel: translate("customer_location_confirm_acceptLabel"),
        rejectLabel: translate("customer_location_confirm_rejectLabel"),
        acceptClass: "btn btn-sm btn-light-primary",
        rejectClass: "btn btn-sm btn-light",
        accept: () => {
          next(true);
        },
        reject: () => {
          next(false);
        },
      });
    } else {
      next(true);
    }
  } else {
    next(true);
  }
});
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  visibility: hidden;
}
.accordion-button:not(.collapsed) {
  color: black;
  background: #fff;
  box-shadow: none;
}

.accordion-item {
  border-color: #e4e6ef;
}
</style>
<style>
#modal-multi-select
  .p-multiselect
  .p-multiselect-label-container
  .p-placeholder {
  padding: 10px;
  font-size: 13px !important;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
}
</style>
